import React from 'react'
import { useSelector } from 'react-redux'
import PortfoliosList from '../contentPages/PortfoliosList'

const PortfoliosLibrary = () => {
	const userLogin = useSelector(state => state.userLogin)
	const { userInfo: user } = userLogin
	const userId = user._id

	return <PortfoliosList userId={userId} />
}

export default PortfoliosLibrary
